import type { SVGProps } from 'react';

export function IconXTwitter(props: SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M26.2109 6H30.3711L21.3477 16.3125L31.9531 30.375H23.6328L17.1289 21.8789L9.6875 30.375H5.52734L15.1953 19.3594L5 6H13.4961L19.4141 13.793L26.2109 6ZM24.7461 27.9141H27.0898L12.2656 8.34375H9.80469L24.7461 27.9141Z"
                fill="currentColor"
            />
        </svg>
    );
}
